export const lifestyle = [
  {
    name: "Lazy Susan Round Platter- Black Gold",
    slug: "lazy-susan-round-platter-black-gold-medium",
    MRP: 4375,
    sellingPrice: 3300,
    category: {
      data: {
        attributes: {
          name: "Lazy Susan",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Lazy Susan Round Platter- Black Gold0",
            url: "/images/products/Lazy_Susan_Round_Platter_Black_Gold_58d8306665.webp",
            size: 260.23,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Pebbles Platter - Black Gold Set of 3 ",
    slug: "pebbles-platter-black-gold-set-of-3",
    MRP: 11500,
    sellingPrice: 8000,
    category: {
      data: {
        attributes: {
          name: "Pebbles",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 1,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Pebbles Platter - Black Gold Set of 3 0",
            url: "/images/products/Pebbles_Platter_Black_Gold_Set_of_3_225a4e4c54.webp",
            size: 56.9,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Pebbles Platter - Black Gold Small",
    slug: "pebbles-platter-black-gold-small",
    MRP: 2799,
    sellingPrice: 1500,
    category: {
      data: {
        attributes: {
          name: "Pebbles",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Pebbles Platter - Black Gold Small0",
            url: "/images/products/Pebbles_Platter_Black_Gold_Small_5e0175f631.webp",
            size: 18.38,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Lazy Susan Round Platter - White Gold",
    slug: "lazy-susan-round-platter-white-gold-medium",
    MRP: 4375,
    sellingPrice: 3300,
    category: {
      data: {
        attributes: {
          name: "Lazy Susan",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Lazy Susan Round Platter - White Gold0",
            url: "/images/products/Lazy_Susan_Round_Platter_White_Gold_49fc3acb20.webp",
            size: 120.23,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: null,
            url: "/images/products/pixelcut_export_10_b5f230db14.jpeg",
            size: 710.96,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: 'Center Gold Tray - White Gold  16"',
    slug: "center-gold-tray-white-gold-16",
    MRP: 3750,
    sellingPrice: 2655,
    category: {
      data: {
        attributes: {
          name: "Tray",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 1,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Wooden Tray white gold",
            url: "/images/products/Wooden_Tray_white_gold_1c3ce62282.webp",
            size: 125.22,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Lazy Susan Round Platter - Gold Leaf",
    slug: "lazy-susan-round-platter-gold-leaf-medium",
    MRP: 4375,
    sellingPrice: 3300,
    category: {
      data: {
        attributes: {
          name: "Lazy Susan",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Lazy Susan Round Platter - Gold Leaf0",
            url: "/images/products/Lazy_Susan_Round_Platter_Gold_Leaf_d2c0403873.webp",
            size: 63.51,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Pebbles Platter - Black Gold Large",
    slug: "pebbles-platter-black-gold-large",
    MRP: 5249,
    sellingPrice: 3500,
    category: {
      data: {
        attributes: {
          name: "Pebbles",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Pebbles Platter - Black Gold Large0",
            url: "/images/products/Pebbles_Platter_Black_Gold_Large_2ab974ab93.webp",
            size: 41.52,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Mini Shovel Platter - Black Gold",
    slug: "mini-shovel-platter-black-gold",
    MRP: 3499,
    sellingPrice: 2000,
    category: {
      data: {
        attributes: {
          name: "Shovel",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Mini Shovel Platter - Black Gold0",
            url: "/images/products/Mini_Shovel_Platter_Black_Gold_c33bcbdf7b.webp",
            size: 78.16,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Lazy Susan Round Platter- Peach Silver",
    slug: "lazy-susan-round-platter-peach-silver-medium",
    MRP: 4375,
    sellingPrice: 3300,
    category: {
      data: {
        attributes: {
          name: "Lazy Susan",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Lazy Susan Round Platter- Peach Silver0",
            url: "/images/products/Lazy_Susan_Round_Platter_Peach_Silver_5567d3e74e.webp",
            size: 58.9,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Pebbles Platter - Black Gold Medium",
    slug: "pebbles-platter-black-gold-medium",
    MRP: 4450,
    sellingPrice: 2850,
    category: {
      data: {
        attributes: {
          name: "Pebbles",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Pebbles Platter - Black Gold Medium0",
            url: "/images/products/Pebbles_Platter_Black_Gold_Medium_4ed169a98f.webp",
            size: 44.35,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Shovel Serving Platter - White Gold Rectangle",
    slug: "shovel-serving-platter-white-gold-rectangle",
    MRP: 3499,
    sellingPrice: 2599,
    category: {
      data: {
        attributes: {
          name: "Shovel",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Shovel Serving Platter - White Gold Rectangle",
            url: "/images/products/Shovel_Serving_Platter_White_Gold_Rectangle1_7bf66d00fc.webp",
            size: 28.98,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "Shovel Serving Platter - White Gold Rectangle0",
            url: "/images/products/Shovel_Serving_Platter_White_Gold_Rectangle_4d975c5d14.webp",
            size: 69.45,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Leaf platter - Black Gold , Wooden Stand",
    slug: "leaf-platter-black-gold-wooden-stand",
    MRP: 4999,
    sellingPrice: 3999,
    category: {
      data: {
        attributes: {
          name: "Platter",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "leaf platter with wooden stand",
            url: "/images/products/leaf_platter_with_wooden_stand_angle_cf769e5e0a.webp",
            size: 182.17,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "leaf platter with wooden stand",
            url: "/images/products/Leaf_platter_d23dbf3333.webp",
            size: 166.71,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "leaf platter without stand",
            url: "/images/products/leaf_platter_without_stand_25edec0c6d.webp",
            size: 78.58,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Wave Platter - White Gold",
    slug: "wave-platter-white-gold",
    MRP: 2999,
    sellingPrice: 2300,
    category: {
      data: {
        attributes: {
          name: "Platter",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Wave Platter - White Gold0",
            url: "/images/products/Wave_Platter_White_Gold_835990f8c0.webp",
            size: 83.56,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Lazy Susan Round Platter- Evil Eye",
    slug: "lazy-susan-round-platter-evil-eye",
    MRP: 4375,
    sellingPrice: 3300,
    category: {
      data: {
        attributes: {
          name: "Lazy Susan",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 1,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Lazy Susan Round Platter- Evil Eye0",
            url: "/images/products/Lazy_Susan_Round_Platter_Evil_Eye_aace86a2c8.webp",
            size: 159.08,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Nachos Platter Black Gold",
    slug: "nachos-platter-black-gold",
    MRP: 3999,
    sellingPrice: 2600,
    category: {
      data: {
        attributes: {
          name: "Platter",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 1,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Nachos Platter Black Gold0",
            url: "/images/products/Nachos_Platter_Black_Gold_aaf1d07024.webp",
            size: 134.49,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: null,
            url: "/images/products/NACHO_PLATTER_copy_3_1_eaf15ab822.jpg",
            size: 41.29,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Mini Shovel Platter - White Gold",
    slug: "mini-shovel-platter-white-gold",
    MRP: 3499,
    sellingPrice: 2250,
    category: {
      data: {
        attributes: {
          name: "Shovel",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Mini Shovel Platter - White Gold0",
            url: "/images/products/Mini_Shovel_Platter_White_Gold_88bdf32700.webp",
            size: 121.38,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Deep Shovel Platter - White Gold",
    slug: "deep-shovel-platter-white-gold",
    MRP: 3999,
    sellingPrice: 2500,
    category: {
      data: {
        attributes: {
          name: "Shovel",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Deep Shovel Platter - White Gold1",
            url: "/images/products/Deep_Shovel_Platter_White_Gold_64f1724065.webp",
            size: 125.03,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "Deep Shovel Platter - White Gold0",
            url: "/images/products/Deep_Shovel_Platter_White_Gold_46ead8398e.webp",
            size: 129.44,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Lazy Susan Round Platter - White Gold",
    slug: "lazy-susan-round-platter-white-gold-large",
    MRP: 4999,
    sellingPrice: 3650,
    category: {
      data: {
        attributes: {
          name: "Lazy Susan",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: null,
            url: "/images/products/lazy_susan_white_gold_15_in_42e08a4619.jpeg",
            size: 65.07,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Lazy Susan Round Platter- Peach Silver",
    slug: "lazy-susan-round-platter-peach-silver-large",
    MRP: 4999,
    sellingPrice: 3650,
    category: {
      data: {
        attributes: {
          name: "Lazy Susan",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Lazy Susan Round Platter- Peach Silver0",
            url: "/images/products/Lazy_Susan_Round_Platter_Peach_Silver_5567d3e74e.webp",
            size: 58.9,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Lazy Susan Round Platter - Gold Leaf",
    slug: "lazy-susan-round-platter-gold-leaf-large",
    MRP: 4999,
    sellingPrice: 3650,
    category: {
      data: {
        attributes: {
          name: "Lazy Susan",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "Lazy Susan Round Platter - Gold Leaf0",
            url: "/images/products/Lazy_Susan_Round_Platter_Gold_Leaf_d2c0403873.webp",
            size: 63.51,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Lazy Susan Round Platter- Black Gold",
    slug: "lazy-susan-round-platter-black-gold-large",
    MRP: 4999,
    sellingPrice: 3500,
    category: {
      data: {
        attributes: {
          name: "Lazy Susan",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: null,
            url: "/images/products/lazy_susan_black_gold_15_angle_2_0b04612b00.jpeg",
            size: 319.25,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
  {
    name: "Fruit Bowl",
    slug: "fruit-bowl",
    MRP: 3999,
    sellingPrice: 3000,
    category: {
      data: {
        attributes: {
          name: "Fruit Bowl",
          __typename: "Category",
        },
        __typename: "CategoryEntity",
      },
      __typename: "CategoryEntityResponse",
    },
    stock: 2,
    images: {
      data: [
        {
          attributes: {
            alternativeText: "fruit bowl",
            url: "/images/products/FRUIT_BOWL_W_and_G_77d87b41d3.webp",
            size: 12.6,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
        {
          attributes: {
            alternativeText: "fruit bowl",
            url: "/images/products/SPLASH_BOWL_WITH_STAND_83ca4c78c3.webp",
            size: 16.92,
            __typename: "UploadFile",
          },
          __typename: "UploadFileEntity",
        },
      ],
      __typename: "UploadFileRelationResponseCollection",
    },
    __typename: "ProductEntity",
  },
];
